import { ErrorCode } from '../types'

export const SecLoansErrorCode = {
  ...ErrorCode,
  IllegalStateError: 'ILLEGAL_APPLICATION_STATE',
  ApplicationAlreadyExists: 'APPLICATION_ALREADY_EXISTS',
} as const

export type SecLoansErrorCode = (typeof SecLoansErrorCode)[keyof typeof SecLoansErrorCode]
